module.exports = __webpack_public_path__ + "img/icon-question-circle.0a607ec2.svg";